/** Shared Forge content contract. Each product uses its own origin and login. */
export type FileView = 'my' | 'team' | 'shared'
export interface ContentFile {
  file_id: string; name: string; version: number; updated_at: string
  size_bytes: number; content_hash: string; access: 'owner' | 'edit' | 'read'
  can_write: boolean; can_share: boolean; library_id: string | null; library_name: string | null
}
export interface ContentTeam { team_id: string; name: string; organization_name: string }
export interface ContentLibrary { library_id: string; name: string; team_id: string; file_count?: number }
export interface ContentShare { recipient_id: string; recipient_label: string; permission: 'read' | 'edit' }
export interface LibraryListing { libraries: ContentLibrary[]; teams: ContentTeam[]; can_write: boolean }
export interface FileListing { files: ContentFile[]; can_write: boolean; offset: number; limit: number }

export async function contentRequest<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers)
  headers.set('X-Office-Request', '1')
  if (options.body && !(options.body instanceof FormData)) headers.set('Content-Type', 'application/json')
  const response = await fetch('/api' + path, { ...options, headers, credentials: 'same-origin', cache: 'no-store' })
  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    throw new Error(body.detail || `File request failed (${response.status})`)
  }
  return response.json() as Promise<T>
}
export const office = <T>(path: string, options?: RequestInit) => contentRequest<T>('/office' + path, options)
export const libraries = <T>(path = '', options?: RequestInit) => contentRequest<T>('/forge/libraries' + path, options)
